/**
 * Key numbers common used keys
 */
// eslint-disable-next-line etc/no-const-enum
export var Keys;
(function (Keys) {
    Keys[Keys["NULL"] = 0] = "NULL";
    Keys[Keys["BACKSPACE"] = 8] = "BACKSPACE";
    Keys[Keys["TAB"] = 9] = "TAB";
    Keys[Keys["ENTER"] = 13] = "ENTER";
    Keys[Keys["SHIFT"] = 16] = "SHIFT";
    Keys[Keys["CTRL_LEFT"] = 17] = "CTRL_LEFT";
    Keys[Keys["ALT"] = 18] = "ALT";
    Keys[Keys["ESCAPE"] = 27] = "ESCAPE";
    Keys[Keys["SPACE"] = 32] = "SPACE";
    Keys[Keys["PAGEUP"] = 33] = "PAGEUP";
    Keys[Keys["END"] = 35] = "END";
    Keys[Keys["HOME"] = 36] = "HOME";
    Keys[Keys["LEFT"] = 37] = "LEFT";
    Keys[Keys["UP"] = 38] = "UP";
    Keys[Keys["RIGHT"] = 39] = "RIGHT";
    Keys[Keys["DOWN"] = 40] = "DOWN";
    Keys[Keys["PRINT_SCREEN"] = 44] = "PRINT_SCREEN";
    Keys[Keys["DELETE"] = 46] = "DELETE";
    /**
     * @deprecated Just for backward compatibility
     */
    Keys[Keys["EIGHT_ASTIRISK"] = 56] = "EIGHT_ASTIRISK";
    Keys[Keys["EIGHT_ASTERISK"] = 56] = "EIGHT_ASTERISK";
    Keys[Keys["B"] = 66] = "B";
    Keys[Keys["I"] = 73] = "I";
    Keys[Keys["U"] = 85] = "U";
    Keys[Keys["Y"] = 89] = "Y";
    Keys[Keys["Z"] = 90] = "Z";
    Keys[Keys["META_LEFT"] = 91] = "META_LEFT";
    Keys[Keys["COMMA"] = 188] = "COMMA";
    Keys[Keys["DASH_UNDERSCORE"] = 189] = "DASH_UNDERSCORE";
    Keys[Keys["PERIOD"] = 190] = "PERIOD";
    /**
     * @deprecated Just for backward compatibility
     */
    Keys[Keys["FORWARDSLASH"] = 191] = "FORWARDSLASH";
    Keys[Keys["FORWARD_SLASH"] = 191] = "FORWARD_SLASH";
    Keys[Keys["GRAVE_TILDE"] = 192] = "GRAVE_TILDE";
    /**
     * Keys below are non-standard, and should be used in ContentEditFeatures only
     */
    Keys[Keys["CONTENTCHANGED"] = 257] = "CONTENTCHANGED";
    Keys[Keys["RANGE"] = 258] = "RANGE";
    Keys[Keys["Ctrl"] = 4096] = "Ctrl";
    Keys[Keys["Meta"] = 8192] = "Meta";
    Keys[Keys["Shift"] = 16384] = "Shift";
})(Keys || (Keys = {}));
//# sourceMappingURL=Keys.js.map